import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@wds/box';
import { List } from '@wds/list';
import { Grid } from '@wds/grid';
import { Input } from '@wds/input';
import { Typography } from '@wds/typography';
import InputSkeleton from './InputSkeleton';
const KeywordsEdit = ({
  themes,
  keywords,
  keywordsLoading,
  setKeywords
}) => {
  const handleKeywordsChange = (e, themeId) => {
    const newKeywords = e.currentTarget.value;
    setKeywords({
      newKeywords,
      themeId
    });
  };
  const themesWithKeywords = themes.map(t => {
    const found = keywords.find(k => k.themeId === t.id);
    return Object.assign(Object.assign({}, t), {
      keywords: found === null || found === void 0 ? void 0 : found.keywords,
      error: found === null || found === void 0 ? void 0 : found.error,
      errorMessages: found === null || found === void 0 ? void 0 : found.errorMessages
    });
  });
  return _jsx(List, {
    dense: true,
    children: themesWithKeywords.map(theme => _jsx(List.Item, {
      children: _jsxs(Grid, {
        noBleeds: true,
        fluid: true,
        children: [_jsx(Grid.Item, {
          xs: 12,
          sm: 12,
          md: 3,
          children: _jsx(Box, {
            mt: 2,
            children: _jsx(Typography, {
              component: "div",
              variant: "body",
              children: theme.theme
            })
          })
        }), _jsx(Grid.Item, {
          xs: 12,
          sm: 12,
          md: 9,
          children: keywordsLoading ? _jsx(InputSkeleton, {}) : _jsx(Input, Object.assign({
            id: `theme-${theme.id}`,
            "data-testid": `theme-${theme.id}`,
            stretched: true,
            value: theme.keywords ? theme.keywords : '',
            onChange: e => handleKeywordsChange(e, theme.id)
          }, theme.error && {
            color: 'warning',
            errorMessage: _jsx(Box, {
              children: (theme === null || theme === void 0 ? void 0 : theme.errorMessages) && theme.errorMessages.map(message => _jsx(Typography, {
                component: "p",
                variant: "bodySm",
                color: "warning",
                children: message
              }, message))
            })
          }))
        })]
      })
    }, theme.id))
  });
};
export default KeywordsEdit;